import { config } from '@/pageConfig/homeowners/us/a-sticky-header-check-our-prices';
import { HomeownersPageTemplate } from '@/pageTemplate/HomeownersPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomeownersPage() {
  const { trackEvent } = useAnalyticsContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    () =>
      trackEvent('homeowners_page.viewed', {
        experiment: 'a-sticky-header-check-our-prices',
      }),
    [],
  );

  return <HomeownersPageTemplate config={config} />;
}
